import { render, staticRenderFns } from "./classInscri.vue?vue&type=template&id=21a76d40&scoped=true&"
import script from "./classInscri.vue?vue&type=script&lang=js&"
export * from "./classInscri.vue?vue&type=script&lang=js&"
import style0 from "./classInscri.vue?vue&type=style&index=0&id=21a76d40&prod&scoped=true&lang=css&"
import style1 from "./classInscri.vue?vue&type=style&index=1&id=21a76d40&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a76d40",
  null
  
)

export default component.exports